// Types only

var _getClosestNode = function getClosestNode(node, until) {
  if (!node) {
    return undefined;
  }
  if (until(node)) {
    return node;
  } else {
    // @ts-ignore
    return _getClosestNode(node.parent, until);
  }
};

/**
 * Whether the node can be clicked
 * @param {Node} node Node
 * @param {unknown} e Click event
 * @returns {boolean} Whether clickable; true means clickable
 */
export { _getClosestNode as getClosestNode };
export function canClickNode(node, e) {
  var _node$componentMeta, _node$componentMeta$a, _node$componentMeta$a2;
  var onClickHook = (_node$componentMeta = node.componentMeta) === null || _node$componentMeta === void 0 ? void 0 : (_node$componentMeta$a = _node$componentMeta.advanced) === null || _node$componentMeta$a === void 0 ? void 0 : (_node$componentMeta$a2 = _node$componentMeta$a.callbacks) === null || _node$componentMeta$a2 === void 0 ? void 0 : _node$componentMeta$a2.onClickHook;
  var canClick = typeof onClickHook === 'function' ? onClickHook(e, node) : true;
  return canClick;
}